import decorativo from '../../../Assets/img/shape13.svg'
import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos'
import PropuestaValor from '../Components/PropuestaValor'
import Asesoramiento from '../Components/Asesoramiento'
import Formulario from '../Components/Formulario';
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from "../Components/Navbar"
import { useConfig } from '../../../context/ConfigContext'
import { FormularioIndividuoConSelect } from '../Components/FormularioIndividuoConSelect'
import { PaisType } from '../diccionario'
import { PreguntasFrecuentes } from '../Components/PreguntasFrecuentes'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

const preguntasFrecuentes: { titulo: string, subTitulo: string, pais: PaisType[] }[] = [
    {
        titulo: '¿Qué es un seguro para PYMES?',
        subTitulo: 'Es un seguro diseñado para proteger a pequeñas y medianas empresas frente a distintos riesgos que puedan afectar sus bienes, operaciones y responsabilidad frente a terceros.',
        pais: ["UY"]
    },
    {
        titulo: '¿Qué cubre un seguro de PYMES?',
        subTitulo: 'Generalmente cubre incendio, robo, fenómenos naturales, daños por agua, responsabilidad civil, equipos electrónicos, rotura de cristales y lucro cesante, entre otras coberturas, dependiendo del plan contratado.',
        pais: ["UY"]
    },
    {
        titulo: '¿Por qué es importante contratar un seguro para mi empresa?',
        subTitulo: 'Un seguro para PYMES permite resguardar tu patrimonio y asegurar la continuidad de tu actividad ante imprevistos que podrían afectar seriamente las finanzas del negocio.',
        pais: ["UY"]
    },
    {
        titulo: '¿Puedo personalizar las coberturas según mi tipo de empresa?',
        subTitulo: 'Sí, existen seguros flexibles que permiten adaptar las coberturas según el tamaño, la actividad y las necesidades específicas de cada empresa.',
        pais: ["UY"]
    },
    {
        titulo: '¿A partir de qué tamaño de empresa se puede contratar un seguro de PYMES?',
        subTitulo: 'Se puede contratar tanto para pequeños emprendimientos como para medianas empresas ya consolidadas. No importa el tamaño, proteger tu actividad siempre es importante.',
        pais: ["UY"]
    },
];

export const TodoRiesgoCorporativo = () => {

    const { config } = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    : "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar
                rubro='auto'
            />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro para Todo Riesgo Operativo'
                    url='#formulario'
                    icon='#icon-seg-tr-corp'
                    subTitulo={{
                        __html:
                            config.pais === "UY" ?
                                "Si tenés un pequeño o mediano negocio, protegerlo es fundamental. Contratá tu seguro para PYMES y asegurá la continuidad de tu empresa ante cualquier imprevisto.<br/><br/>¿Empezamos?"
                                :
                                "Protege el patrimonio de tu empresa y/o industria resguardando los riesgos específicos de la actividad y procesos industriales. <br/><br/>¿Empezamos?"
                    }}
                />
                <div className="pt-70 pt-lg-80 pb-40 bg-primary position-relative">
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                {config.pais === "UY" ?
                                    `Este tipo de seguro ofrece una protección integral para tu empresa, cubriendo tanto daños materiales como responsabilidades legales y pérdidas económicas derivadas de siniestros.`
                                    :
                                    `Es un seguro que permite respaldar en forma íntegra las operaciones comerciales e industriales de tu empresa.<br />
                             Es la opción más idónea para reducir el impacto de múltiples riesgos de tu actividad, posibilitando el diseño de una póliza ajustada a las características y necesidades de tu empresa.`
                                }
                            </p>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Los planes pueden incluir:
                            </p>
                        </div>

                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        {
                                            config.pais === "UY" ?
                                                <>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Incendio y explosión:</b> Cubre daños en el edificio, mobiliario, mercadería y maquinaria a causa de incendios o explosiones accidentales.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Robo o hurto:</b> Ofrece protección frente a la sustracción de bienes de la empresa, incluyendo daños causados durante el hecho.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Fenómenos naturales:</b> Cubre daños provocados por granizo, viento, inundaciones, tormentas u otros eventos climáticos.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Daños por agua:</b> Protege contra daños por roturas de cañerías, filtraciones o anegamientos accidentales.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Rotura de cristales: </b>Cubre la reparación o reemplazo de vidrios y cristales dañados en el local comercial.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Equipos electrónicos:</b> Indemniza ante daños o robos de computadoras, impresoras, registradoras y otros equipos de uso comercial
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Responsabilidad civil:</b> Cubre reclamos de terceros por daños materiales o personales ocasionados en el ejercicio de la actividad comercial.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Lucro cesante:</b> Ofrece una compensación económica por pérdida de ingresos si la empresa debe interrumpir su actividad a raíz de un siniestro.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Asistencia 24/7:</b> Servicios de emergencia como cerrajería, plomería y vigilancia, disponibles ante eventos cubiertos.
                                                    </li>
                                                </>
                                                :
                                                <>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Daños a la propiedad:</b> Cubre los daños materiales o pérdidas que pueda sufrir la propiedad de la empresa, como edificios, estructuras, equipos electrónicos, maquinarias, inventarios y otros activos, debido a diversos eventos, como incendios, inundaciones, robos, vandalismo, explosiones, terremotos, entre otros.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Responsabilidad civil:</b> Cubre los gastos legales y las indemnizaciones a terceros por lesiones personales o daños a la propiedad que puedan ocurrir como resultado de las operaciones comerciales de la empresa asegurada.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                        <b>Interrupción del negocio:</b> En caso de que las operaciones comerciales se vean interrumpidas debido a eventos cubiertos, el seguro puede cubrir la pérdida de ingresos y los gastos fijos durante el período de interrupción. Esto ayuda a compensar las pérdidas económicas y permite que la empresa continúe funcionando mientras se resuelven los problemas.
                                                    </li>
                                                    <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                                        <b> Gastos adicionales:</b> Cubre los gastos adicionales y razonables que la empresa pueda incurrir para minimizar o mitigar los daños después de un evento cubierto.
                                                    </li>
                                                </>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Formulario
                    rubro='TRO'
                    titulo='Cotizá seguro para Todo Riesgo Operativo'
                    origen={config.pais === "UY" ? "UY-SEGURARSE" : "SEGURARSE"}
                />
                <PorQueElegirnos />
                <PropuestaValor />
                {
                    config.pais === "AR" &&
                    <Asesoramiento />
                }
                {
                    config.pais === "UY" &&
                    <PreguntasFrecuentes
                        faqs={preguntasFrecuentes.filter(faq => faq.pais.includes(config.pais))}
                    />
                }
            </div>
        </>
    )
}
